// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family:
    -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
    'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body > div[tabindex='-1']:not(.chakra-portal):not(.fb-changelog-popup-wrapper) {
  z-index: 1400 !important;
}

#react-confirm-alert {
  position: fixed;
  z-index: 1400;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

:where(img, svg, video, canvas, audio, iframe, embed, object) {
  display: initial !important;
}

.chakra-collapse[style*="height: auto"] { overflow: initial !important }
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;gCAE8B;EAC9B,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,0CAA0C,6BAA6B","sourcesContent":["body {\n  margin: 0;\n  font-family:\n    -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',\n    'Helvetica Neue', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nbody > div[tabindex='-1']:not(.chakra-portal):not(.fb-changelog-popup-wrapper) {\n  z-index: 1400 !important;\n}\n\n#react-confirm-alert {\n  position: fixed;\n  z-index: 1400;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n:where(img, svg, video, canvas, audio, iframe, embed, object) {\n  display: initial !important;\n}\n\n.chakra-collapse[style*=\"height: auto\"] { overflow: initial !important }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
